import { Flex } from '@mantine/core';
import { LeftSidebar } from '@/layouts/LeftSidebar/LeftSidebar.tsx';
import { ReactNode, useMemo } from 'react';
import { useMatch } from 'react-router-dom';

type props = {
  children: ReactNode;
};

const LeftSidebarWrapper = ({ children }: props) => {
  const isAutomationsPage = !!useMatch('/automations');
  const isSuiteList = !!useMatch('/automation-suites');
  const isSuiteDetail = !!useMatch('/automation-suites/:suiteId');
  const isIntegrationsPage = !!useMatch('/integrations');
  const isHumanDecisionsPage = !!useMatch('/human-decisions');
  const isAutomationPage = !!useMatch('/automations/:automationId');

  const { showLeftSidebar, includePadding } = useMemo(() => {
    const show =
      isAutomationsPage ||
      isSuiteList ||
      isSuiteDetail ||
      isIntegrationsPage ||
      isHumanDecisionsPage ||
      isAutomationPage;
    return { showLeftSidebar: show, includePadding: !isAutomationPage };
  }, [
    isAutomationPage,
    isAutomationsPage,
    isHumanDecisionsPage,
    isIntegrationsPage,
    isSuiteList,
    isSuiteDetail,
  ]);

  if (!showLeftSidebar) {
    return children;
  }

  return (
    <Flex w={'100%'} h={'100%'}>
      {/* Left Sidebar with fixed width */}
      <LeftSidebar />
      {/* Right content area that fills remaining space and scrolls vertically */}
      {includePadding ? (
        <Flex
          direction="column"
          w="100%"
          h="100%"
          px="lg"
          pt="lg"
          style={{ overflowY: 'auto', overflowX: 'hidden' }}
        >
          {children}
        </Flex>
      ) : (
        children
      )}
    </Flex>
  );
};

export default LeftSidebarWrapper;
